import api from './api'
import type { LocationHistory } from '../types/index'

export const locationService = {
  async postLocation(data: {
    runnerId: number
    latitude: number
    longitude: number
    accuracy: number
    timestamp: string
  }): Promise<{ id: number; success: boolean }> {
    const response = await api.post('/location', data)
    return response.data
  },

  async getLocationHistory(runnerId: number): Promise<LocationHistory[]> {
    const response = await api.get(`/location/${runnerId}`)
    return response.data
  },

  async getAllLatestLocations(): Promise<Array<{ runner_id: number; latitude: number; longitude: number; accuracy: number; timestamp: string }>> {
    const response = await api.get('/location')
    return response.data
  },
}
